/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{ObservableBase as o}from"../ObservableBase.js";class s extends o{notify(){const o=this._observers;if(o&&o.length>0){const s=o.slice();for(const o of s)o.onInvalidated(),o.onCommitted()}}}export{s as SimpleObservable};
